import React from "react";
import { rgba } from "polished";
import styled from "styled-components";
import { Box, Flex } from "rebass";
import Text from "./Text";
import * as Icon from "react-feather";
import { ThemeProvider } from "styled-components";
import invertTheme from "../invertTheme";

const Wrapper = styled.div`
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  background-color: #363636;
  box-shadow: 0 -1px 4px 0 ${rgba("#363636", 1 / 10)};

  @media (min-width: 512px) {
    display: none;
  }
`;

const MobileBar = props => (
  <ThemeProvider theme={invertTheme}>
    <Wrapper>
      <Box mx={4} my={3}>
        <Flex justify={`space-around`}>
          <a href={`mailto:` + props.emailAddress}>
            <Flex>
              <Icon.Phone size={24} color="#fff" strokeWidth={1.5} />
              <Text
                children={
                  props.windowLang === "en-us"
                    ? "Call us"
                    : props.windowLang === "es-mx" ? "Llámenos" : "اتصل بنا"
                }
                ml={2}
              />
            </Flex>
          </a>
          <a href={`tel:` + props.phoneNumber}>
            <Flex>
              <Icon.Mail size={24} color="#fff" strokeWidth={1.5} />
              <Text
                children={
                  props.windowLang === "en-us"
                    ? "Email us"
                    : props.windowLang === "es-mx" ? "Email" : "أرسل لنا"
                }
                ml={2}
              />
            </Flex>
          </a>
        </Flex>
      </Box>
    </Wrapper>
  </ThemeProvider>
);

export default MobileBar;



// WEBPACK FOOTER //
// ./src/components/MobileBar.js